<template>
  <div class="product-describing-form">
    <div class="main-container">
      <form @submit.prevent="submitForm()">
        <div class="grid-container first">
          <div class="item">
            <base-select
              id="applicationTypes"
              :options="
                applicationTypes.filter((x) => x.code !== 3 && x.code !== 4)
              "
              fieldLabel="Veri Grubu"
              placeholder="Seçiniz"
              :clearable="false"
              v-model="formItems.applicationTypeId"
              :selected-id="formItems.applicationTypeId"
              :error="$v.formItems.applicationTypeId.$error"
            />
          </div>
          <div class="item">
            <div v-if="!formItems.id">
              <base-select
                id="application"
                :options="applications"
                fieldLabel="İşlem Platformu"
                placeholder="Seçiniz"
                :clearable="false"
                v-model="formItems.applicationId"
                :selected-id="formItems.applicationId"
                :error="$v.formItems.applicationId.$error"
              />
            </div>
            <div v-else class="disable-selectbox">
              <p class="form-control-label">Vendor</p>
              <ul>
                <li>{{ formItems.name }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="grouped-container">
          <div class="title">İşlem Yeri</div>
          <div class="input-container">
            <div class="grid-container">
              <div class="item">
                <div v-if="!formItems.id">
                  <base-select
                    :options="platforms"
                    fieldLabel="İşlem Yeri"
                    placeholder="Seçiniz"
                    :clearable="false"
                    v-model="formItems.platform.platformId"
                    :selected-id="formItems.platform.platformId"
                    :error="$v.formItems.platform.platformId.$error"
                  />
                </div>
                <div v-else class="disable-selectbox">
                  <p>İşlem Yeri</p>
                  <ul>
                    <li>{{ formItems.platform.name }}</li>
                  </ul>
                </div>
              </div>
              <div class="item input-item">
                <base-input
                  class="item-input-container"
                  inputType="number"
                  labelText="Maliyet"
                  cssClass="input-style"
                  v-model="formItems.platform.cost"
                  :error="$v.formItems.platform.cost.$error"
                />
              </div>
              <div class="item input-item">
                <base-input
                  class="item-input-container"
                  inputType="number"
                  labelText="Fiyat"
                  cssClass="input-style"
                  @change="calculate(null, null, 'platform')"
                  v-model="formItems.platform.price"
                  :error="$v.formItems.platform.price.$error"
                />
              </div>
              <div class="item input-item">
                <base-input
                  class="item-input-container"
                  inputType="text"
                  labelText="Çarpan Değeri"
                  cssClass="input-style"
                  :isDisabled="true"
                  v-model="priceMultiplier"
                />
              </div>
              <div class="item input-item">
                <base-input
                  class="item-input-container"
                  inputType="text"
                  labelText="BES ve FON Büyüklüğü"
                  cssClass="input-style"
                  v-model="formItems.platform.fundAmount"
                  :isDisabled="true"
                  :error="$v.formItems.platform.fundAmount.$error"
                />
              </div>
              <div class="item input-item">
                <base-input
                  class="item-input-container"
                  inputType="number"
                  labelText="Komisyon"
                  cssClass="input-style"
                  v-model="formItems.platform.commissionAmount"
                  :isDisabled="true"
                  :error="$v.formItems.platform.commissionAmount.$error"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(licenseData, index) in licences"
          :key="index"
          class="grouped-container with-button"
        >
          <div class="title">Lisans Bilgileri</div>
          <div class="input-container">
            <div class="grid-container">
              <div class="item short">
                <base-select
                  :options="markets"
                  fieldLabel="Piyasa"
                  placeholder="Seçiniz"
                  :clearable="false"
                  v-model="licenseData.licenceId"
                  :selected-id="licenseData.licenceId"
                  :error="$v.formItems.licences.$each[index].licenceId.$error"
                  @change="setName(index, null, 'markets', 'licenceId')"
                />
              </div>
            </div>
          </div>
          <div
            v-for="(perspective, perspectivesIndex) in licenseData.perspectives"
            :key="perspectivesIndex + '-1'"
            class="input-container"
          >
            <div class="grouped-container with-button inner">
              <div class="title">Derinlik</div>
              <div class="grid-container">
                <div class="item select-item">
                  <base-select
                    :options="perspectives"
                    fieldLabel="Derinlik"
                    placeholder="Seçiniz"
                    :clearable="false"
                    class="item-select"
                    v-model="perspective.perspectiveId"
                    :selected-id="perspective.perspectiveId"
                    @change="
                      setName(
                        index,
                        perspectivesIndex,
                        'perspectives',
                        'perspectiveId'
                      )
                    "
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="number"
                    labelText="Maliyet"
                    v-model="perspective.cost"
                    cssClass="input-style"
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="number"
                    labelText="Fiyat"
                    v-model="perspective.price"
                    cssClass="input-style"
                    @change="
                      calculate(index, perspectivesIndex, 'perspectives')
                    "
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="text"
                    labelText="Çarpan Değeri"
                    :isDisabled="true"
                    v-model="priceMultiplier"
                    cssClass="input-style"
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="number"
                    labelText="BES ve FON Büyüklüğü"
                    v-model="perspective.fundAmount"
                    cssClass="input-style"
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="number"
                    labelText="Komisyon"
                    v-model="perspective.commissionAmount"
                    cssClass="input-style"
                  />
                </div>
              </div>
              <div
                v-if="perspectivesIndex === 0"
                @click.prevent="addRemovePerspective(index, null)"
                class="add-button"
              >
                <base-icon :name="'plus-circle'" />
              </div>
              <div
                v-else
                @click.prevent="addRemovePerspective(index, perspectivesIndex)"
                class="add-button remove"
              >
                <base-icon :name="'close-colored'" />
              </div>
            </div>
          </div>
          <hr />
          <div
            v-for="(vendor, vendorIndex) in licenseData.vendors"
            :key="vendorIndex"
            class="input-container"
          >
            <div class="grouped-container with-button inner">
              <div class="title">AKD</div>
              <div class="grid-container">
                <div class="item select-item">
                  <base-select
                    :options="vendors"
                    fieldLabel="AKD"
                    placeholder="Seçiniz"
                    :clearable="false"
                    class="item-select"
                    v-model="vendor.vendorId"
                    :selected-id="vendor.vendorId"
                    @change="setName(index, vendorIndex, 'vendors', 'vendorId')"
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="number"
                    labelText="Maliyet"
                    v-model="vendor.cost"
                    cssClass="input-style"
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="number"
                    labelText="Fiyat"
                    v-model="vendor.price"
                    cssClass="input-style"
                    @change="calculate(index, vendorIndex, 'vendors')"
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="text"
                    labelText="Çarpan Değeri"
                    :isDisabled="true"
                    v-model="priceMultiplier"
                    cssClass="input-style"
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="number"
                    labelText="BES ve FON Büyüklüğü"
                    v-model="vendor.fundAmount"
                    cssClass="input-style"
                  />
                </div>
                <div class="item input-item">
                  <base-input
                    class="item-input-container"
                    inputType="number"
                    labelText="Komisyon"
                    v-model="vendor.commissionAmount"
                    cssClass="input-style"
                  />
                </div>
              </div>
              <div
                v-if="vendorIndex === 0"
                @click.prevent="addRemoveVendor(index, null)"
                class="add-button"
              >
                <base-icon :name="'plus-circle'" />
              </div>
              <div
                v-else
                @click.prevent="addRemoveVendor(index, vendorIndex)"
                class="add-button remove"
              >
                <base-icon :name="'close-colored'" />
              </div>
            </div>
          </div>
          <div
            v-if="index === 0"
            @click.prevent="addRemovelicenseData()"
            class="add-button"
          >
            <base-icon :name="'plus-circle'" />
          </div>
          <div
            v-else
            @click.prevent="addRemovelicenseData(index)"
            class="add-button remove"
          >
            <base-icon :name="'close-colored'" />
          </div>
        </div>
        <div class="grouped-container">
          <div class="title">Algoritmalar</div>
          <div class="input-container">
            <div class="grid-container">
              <div class="item select-item">
                <base-select
                  v-if="algorithms.length"
                  :options="algorithms"
                  fieldLabel="Algoritmalar"
                  placeholder="Seçiniz"
                  :clearable="false"
                  :multiple="true"
                  v-model="formItems.algorithmIds"
                  :selected-id="formItems.algorithmIds"
                  @change="
                    formatMultiselectValues(
                      'algorithmId',
                      'algorithmIds',
                      'algorithms',
                      null
                    )
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="grouped-container">
          <div class="title">Ek Paketler</div>
          <div class="input-container">
            <div class="grid-container">
              <div class="item">
                <div class="disable-selectbox multiple">
                  <p>Araştırma ve Diğer</p>
                  <ul>
                    <li v-for="item in formItems.researchs" :key="item.id">
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="grid-container">
              <div class="item">
                <base-select
                  v-if="foreignIndices.length"
                  :options="foreignIndices"
                  fieldLabel="Yabancı Endeksler"
                  placeholder="Seçiniz"
                  :clearable="false"
                  :multiple="true"
                  v-model="formItems.foreignIndiceIds"
                  :selected-id="formItems.foreignIndiceIds"
                  @change="
                    formatMultiselectValues(
                      'foreignIndiceId',
                      'foreignIndiceIds',
                      'foreignIndices',
                      null
                    )
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="upload-main-container">
          <photo-upload :base64Img="setPhotoForForm" />
        </div>
        <hr />
        <div class="button-container">
          <base-button
            @click="
              $router.push({
                query: { item: 7 },
              })
            "
            type="button"
            class="ok-btn cancel"
            >Vazgeç</base-button
          >
          <base-button
            type="submit"
            class="ok-btn"
            @click="checkIsSaveClicked"
            :class="isSaveClicked ? 'disabled' : ''"
            >Kaydet</base-button
          >
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { BaseSelect, BaseInput, BaseIcon, BaseButton } from "@/components";
import { required, minValue } from "vuelidate/lib/validators";
import PhotoUpload from "@/components/productAndPackage/PhotoUpload";
import mixins from "../../mixins/index";
import { mapGetters } from "vuex";

export default {
  name: "ProductDescribing",
  mixins: [mixins],
  props: {
    clickedNewItemBtn: Boolean,
    fullData: [],
    selectboxItems: [],
    costMultiplier: Number,
  },
  data() {
    return {
      licences: [],
      basePerspectiveModel: {
        perspectiveId: 0,
        cost: 0,
        price: 0,
        priceMultiplier: 0,
        fundAmount: 0,
        commissionAmount: 0,
        name: "",
      },
      baseVendorModel: {
        vendorId: 0,
        cost: 0,
        price: 0,
        priceMultiplier: 0,
        fundAmount: 0,
        commissionAmount: 0,
        name: "",
      },
      licenseBaseModel: {
        licenceId: 0,
        name: "",
        perspectives: [],
        vendors: [],
      },
      formItems: {
        applicationTypeId: 0,
        applicationId: 0,
        name: "",
        platform: {
          platformId: 0,
          cost: 0,
          price: 0,
          priceMultiplier: 0,
          fundAmount: 0,
          commissionAmount: 0,
        },
        licences: [],
        researchIds: [],
        researchs: [],
        foreignIndiceIds: [],
        algorithmsIds: [],
        foreignIndices: [],
        algorithmIds: [],
        algorithms: [],
      },
      calculateOnLoad: false,
      platforms: [],
      applications: [],
      applicationTypes: [],
      markets: [],
      perspectives: [],
      vendors: [],
      algorithms: [],
      researchs: [],
      foreignIndices: [],
      siteSettings: {},
      loadStatusComplate: false,
      priceMultiplier: String(this.costMultiplier),
      isSaveClicked: false,
    };
  },
  components: {
    BaseSelect,
    BaseInput,
    BaseIcon,
    BaseButton,
    PhotoUpload,
  },
  validations: {
    formItems: {
      applicationTypeId: {
        required,
        minValue: minValue(1),
      },
      applicationId: {
        required,
        minValue: minValue(1),
      },
      platform: {
        platformId: {
          required,
          minValue: minValue(1),
        },
        cost: {
          required,
          minValue: minValue(0),
        },
        price: {
          required,
          minValue: minValue(0),
        },
        priceMultiplier: {
          required,
          minValue: minValue(0),
        },
        fundAmount: {
          required,
          minValue: minValue(0),
        },
        commissionAmount: {
          required,
          minValue: minValue(0),
        },
      },
      licences: {
        $each: {
          licenceId: {
            required,
            minValue: minValue(1),
          },
        },
      },
    },
  },
  methods: {
    ...mapGetters(["getProductManagementProductFilter"]),
    addRemovelicenseData(index = null) {
      if (index === null) {
        if (this.licenseBaseModel.perspectives.length === 0) {
          this.licenseBaseModel.perspectives.push(
            JSON.parse(JSON.stringify(this.basePerspectiveModel))
          );
        }
        if (this.licenseBaseModel.vendors.length === 0) {
          this.licenseBaseModel.vendors.push(
            JSON.parse(JSON.stringify(this.baseVendorModel))
          );
        }
        this.licences.push(JSON.parse(JSON.stringify(this.licenseBaseModel)));
      } else {
        this.licences.splice(index, 1);
      }
    },
    addRemovePerspective(index, subIndex = null) {
      if (subIndex === null) {
        this.licences[index].perspectives.push(
          JSON.parse(JSON.stringify(this.basePerspectiveModel))
        );
      } else {
        this.licences[index].perspectives.splice(subIndex, 1);
      }
    },
    addRemoveVendor(index, subIndex = null) {
      if (subIndex === null) {
        this.licences[index].vendors.push(
          JSON.parse(JSON.stringify(this.baseVendorModel))
        );
      } else {
        this.licences[index].vendors.splice(subIndex, 1);
      }
    },
    checkIsSaveClicked() {
      this.isSaveClicked = true;
    },
    /*formatDataForSelect(list) {
      list.unshift({ Key: 0, Value: "Seçiniz" });
      return list.map((data) => {
        return { code: data.Key, label: data.Value };
      });
    },*/
    calculate(index, subIndex, prop) {
      if (this.calculateOnLoad) {
        let item = {};
        if (index !== null && subIndex !== null) {
          item = this.formItems.licences[index][prop][subIndex];
        } else {
          item = this.formItems[prop];
        }
        item.commissionAmount = Math.round(
          Number(item.price) * Number(this.costMultiplier)
        );
        let calculatedFundAmount = (Number(item.commissionAmount) / 1.2) * 1200;

        item.fundAmount = this.integersToRound(
          calculatedFundAmount,
          String(item.commissionAmount).length
        );
      }
    },
    setName(index, subIndex, arrayName, idPropName) {
      setTimeout(() => {
        let item = {};
        if (subIndex !== null) {
          item = this.formItems.licences[index][arrayName][subIndex];
        } else {
          item = this.formItems.licences[index];
        }
        item.name = this.findName(arrayName, item[idPropName]);
      }, 10);
    },
    findName(arrayName, filterValue) {
      return this[arrayName].find((x) => x.code === filterValue).label;
    },
    formatMultiselectValues(idPropName, sourceArray, definationArray, index) {
      setTimeout(() => {
        let selectedIds =
          index !== null
            ? this.formItems.licences[index][sourceArray]
            : this.formItems[sourceArray];
        const items = this[
          index !== null ? sourceArray : definationArray
        ].filter((x) => selectedIds.includes(x.code));
        const formatedList = items.map((x) => {
          return { [idPropName]: x.code, name: x.label };
        });
        if (index !== null) {
          this.formItems.licences[index][definationArray] = formatedList;
        } else {
          this.formItems[definationArray] = formatedList;
        }
      }, 10);
    },
    formatArray(source, prop) {
      const newArray = [];
      source.forEach((element) => {
        newArray.push(element[prop]);
      });
      return newArray;
    },
    formatDecimal(obj, array = null) {
      if (array !== null) {
        array.forEach((item) => {
          item.commissionAmount = Number(item.commissionAmount);
          item.cost = Number(item.cost);
          item.fundAmount = Number(item.fundAmount);
          item.price = Number(item.price);
          item.priceMultiplier = this.priceMultiplier;
        });
        return array;
      } else {
        obj.commissionAmount = Number(obj.commissionAmount);
        obj.cost = Number(obj.cost);
        obj.fundAmount = Number(obj.fundAmount);
        obj.price = Number(obj.price);
        obj.priceMultiplier = this.priceMultiplier;
        return obj;
      }
    },
    setSelectedItem(item) {
      const selectedItem = JSON.parse(JSON.stringify(item));
      setTimeout(() => {
        this.formItems.applicationId = selectedItem.applicationId;
        this.formItems.applicationTypeId = selectedItem.applicationTypeId;
        this.formItems.name = selectedItem.name;
        this.formItems.platform = this.formatDecimal(selectedItem.platform);
        this.formItems.id = selectedItem.id;
        this.formItems.algorithmIds = this.formatArray(
          selectedItem.algorithms,
          "algorithmId"
        );
        this.formItems.algorithms = selectedItem.algorithms;
        selectedItem.licences.forEach((element) => {
          const perspectives = this.formatDecimal({}, element.perspectives);
          const vendors = this.formatDecimal({}, element.vendors);
          if (element.perspectives.length === 0) {
            perspectives.push(this.basePerspectiveModel);
          }
          if (element.vendors.length === 0) {
            vendors.push(this.baseVendorModel);
          }
          this.formItems.licences.push({
            id: element.id,
            licenceId: element.licenceId,
            name: element.name,
            perspectives: perspectives,
            vendors: vendors,
          });
        });
        this.formItems.researchs = selectedItem.researchs;
        this.formItems.foreignIndices = selectedItem.foreignIndices;
        this.formItems.foreignIndiceIds = this.formatArray(
          selectedItem.foreignIndices,
          "foreignIndiceId"
        );
      });
    },
    submitForm() {
      this.$v.formItems.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const formDatas = JSON.parse(JSON.stringify(this.formItems));
      const formatedPlatform = this.formatDecimal(formDatas.platform);
      formDatas.licences.forEach((item) => {
        item.perspectives = this.formatDecimal({}, item.perspectives);
        item.vendors = this.formatDecimal({}, item.vendors);
        for (let i = 0; i < item.perspectives.length; i++) {
          const perspective = item.perspectives[i];
          if (perspective.perspectiveId === 0) {
            item.perspectives.splice(i, 1);
          }
        }
        for (let i = 0; i < item.vendors.length; i++) {
          const vendor = item.vendors[i];
          if (vendor.vendorId === 0) {
            item.vendors.splice(i, 1);
          }
        }
      });
      const researchs = this.researchs.map((x) => {
        return { researchId: x.code, name: x.label };
      });
      const params = {
        applicationTypeId: formDatas.applicationTypeId,
        applicationId: formDatas.applicationId,
        name: this.findName("applications", formDatas.applicationId),
        platform: {
          ...formatedPlatform,
          name: this.findName("platforms", formDatas.platform.platformId),
        },
        licences: [...formDatas.licences],
        algorithms: [...formDatas.algorithms],
        researchs: researchs,
        foreignIndices: [...formDatas.foreignIndices],
        year: this.getProductManagementFilters().year
          ? this.getProductManagementFilters().year
          : null,
        month: this.getProductManagementFilters().month
          ? this.getProductManagementFilters().month
          : null,
      };
      const id = Number(this.$route.query.featureSettingId);
      params.id = 0;
      if (id > 0) {
        params.id = id;
      }
      if (formDatas.imageFileBase64 !== "") {
        params.imageFileBase64 = this.formItems.imageFileBase64;
      }
      this.$emit("submit-form", params);
    },

    setPhotoForForm(base64) {
      this.formItems.imageFileBase64 = base64;
    },
  },
  computed: {
    getProductManagementFilters() {
      return this.getProductManagementProductFilter;
    },
  },
  watch: {
    fullData: {
      handler(val) {
        const id = Number(this.$route.query.featureSettingId);
        const platformId = Number(this.$route.query.platformId);
        if (id > 0) {
          const item = val.find(
            (x) => x.id === id && x.platformId === platformId
          );
          this.setSelectedItem(item);
        }
      },
      deep: true,
    },
    selectboxItems: {
      handler(val) {
        const firstItem = { code: 0, label: "Seçiniz" };
        this.applications = val.find((x) => x.name === "Applications").values;
        this.applications.unshift(firstItem);
        this.applicationTypes = val.find(
          (x) => x.name === "ApplicationTypes"
        ).values;
        this.applicationTypes.unshift(firstItem);
        this.platforms = val.find((x) => x.name === "Platforms").values;
        this.platforms.unshift(firstItem);
        this.markets = val.find((x) => x.name === "Markets").values;
        this.markets.unshift(firstItem);
        this.perspectives = val.find((x) => x.name === "Perspectives").values;
        this.perspectives.unshift(firstItem);
        this.vendors = val.find((x) => x.name === "Vendors").values;
        this.vendors.unshift(firstItem);
        this.researchs = val.find((x) => x.name === "Researchs").values;
        setTimeout(() => {
          this.algorithms = val.find(
            (x) => x.name === "AlgorithmAndServers"
          ).values;
          this.algorithms.unshift(firstItem);

          this.foreignIndices = val.find(
            (x) => x.name === "ForeignIndices"
          ).values;
        }, 300);
      },
      deep: true,
    },
    costMultiplier(val) {
      const priceMultiplier = Number(val);
      this.priceMultiplier = priceMultiplier;
      this.basePerspectiveModel.priceMultiplier = priceMultiplier;
      this.baseVendorModel.priceMultiplier = priceMultiplier;
      this.formItems.platform.priceMultiplier = priceMultiplier;
      const featureSettingId = Number(this.$route.query.featureSettingId);
      if (featureSettingId === 0) {
        this.addRemovelicenseData();
      }
    },
  },
  created() {
    this.calculateOnLoad = false;
  },
  mounted() {
    this.formItems.licences = this.licences;
    this.$nextTick(() => {
      setTimeout(() => {
        this.calculateOnLoad = true;
      }, 300);
    });
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: white;
  margin-top: 20px;
  .grouped-container {
    position: relative;
    border-radius: 6px;
    border: solid 3px #d4d4d7;
    margin-bottom: 70px;
    box-sizing: border-box;
    padding-bottom: 28px;
    hr {
      border: none;
      border-top: 1px solid #d4d4d7;
      margin: 30px 0 0 0;
    }
    .input-container {
      padding: 18px 18px 0px 20px;
    }
    &.with-button {
      width: 93%;
      .add-button {
        position: absolute;
        right: -56px;
        top: 50%;
        transform: translateY(-50%);
        width: 48px;
        height: 48px;
        padding: 12px;
        border-radius: 4px;
        background-color: #242424;
        box-sizing: border-box;
        cursor: pointer;
        color: white;
        @media (max-width: 768px) {
          position: relative;
          top: auto;
          right: auto;
          margin: 0 auto;
          margin-top: 10px;
          transform: translateY(0px);
        }
        &.remove {
          background-color: #dc3545;
          color: white;
        }
      }
    }
    .title {
      position: absolute;
      top: -9px;
      left: 40px;
      font-weight: bold;
      font-size: 14px;
      color: #242424;
      background-color: white;
      padding: 0 8px;
    }
    &.inner {
      padding: 18px 22px 29px 20px;
      margin: 20px 0 0 6px;
      .title {
        left: 10px;
      }
    }
  }
  .upload-main-container {
    width: 300px;
    .upload-container {
      padding: 0;
    }
  }
  .button-container {
    padding: 10px 0 30px 0;
    text-align: right;
    .ok-btn {
      display: unset;
      width: 220px;
      height: 50px;
      background-color: #28a745;
      &.disabled {
        pointer-events: none;
      }
      &.cancel {
        width: 150px;
        background-color: transparent;
        color: var(--grayscale-60);
        margin-right: 20px;
      }
    }
  }
}

.grid-container {
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  align-items: stretch;
  &.first {
    margin-bottom: 30px;
    margin-left: -10px;
    margin-right: -10px;
  }
  &.between {
    justify-content: space-between;
    flex-flow: row;
  }
  &.centered {
    align-content: center;
  }
  .break {
    width: 100%;
  }
  .item {
    flex-grow: 1;
    padding: 0 5px;
    box-sizing: border-box;
    &.long {
      width: 70%;
    }
    &.short {
      max-width: 295px;
    }
    &.input-item {
      @media (min-width: 1024px) {
        max-width: 35%;
      }
      padding: 6px 0;
    }
    &.select-item {
      width: auto;
      padding: 0 9px;
    }
    .disable-selectbox {
      position: relative;
      border: 1px solid #d4d4d7;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 11px 11px;
      margin-top: 19px;
      p {
        font-size: 12px;
        color: var(--grayscale-70);
        position: absolute;
        top: -7px;
        left: 15px;
        z-index: 2;
        background-color: white;
      }
      li {
        font-size: 14px;
        display: inline-block;
        align-items: center;
        line-height: 1.4;
        margin: 4px 2px 0px 2px;
        padding: 0 0.25em;
        &.multiple {
          background-color: #f0f0f0;
          border: 1px solid rgba(60, 60, 60, 0.26);
        }
      }
      &.multiple {
        padding: 10px 11px;
        margin-top: 12px;
        li {
          border-radius: 4px;
          background-color: #f0f0f0;
          border: 1px solid rgba(60, 60, 60, 0.26);
        }
      }
    }
  }
}
.product-managements-container {
  .form-group {
    margin: 0;
    width: 100%;
  }
}
</style>
<style lang="scss">
.input-style {
  width: 100% !important;
  box-sizing: border-box;
  height: 47px !important;
}
</style>
